export const IMAGE_PLACEHOLDERS = {
    AVATAR: 'https://static.wixstatic.com/media/5e9922_b58c6b55f874409488b37fd06560b8ae~mv2.png',
    GENERIC_IN_COLUMN: 'https://static.wixstatic.com/media/5e9922_09260fd72a464111a3a9c4c6a8820a2d~mv2.png',
    GENERIC: 'https://static.wixstatic.com/media/5e9922_cea8153bcb774952af03e00be55c4c75~mv2.png',
};
//# sourceMappingURL=placeholder.js.map